export default __webpack_public_path__ + "static/media/downloadIcon.8dd3ee2f.svg";